import axios from 'axios'
// import store from '@/store'
import {  Message } from 'element-ui'

// const requestId = localStorage.getItem('DITSEUQER')
const service = axios.create({
  baseURL: `${process.env.VUE_APP_BASE_API}`,
  // baseURL: `http://hngl.henanmingxun.com/api/`,
  // withCredentials: true, // send cookies when cross-domain requests
  timeout: 30000
})
// request interceptor
service.interceptors.request.use(
  config => {
    // config.headers = {
    //   'Content-Type': config.contentType || 'application/json',
    // }

    // if (store.getters.token) {
    //   config.headers['token'] = getToken()
    // }
    return config
  },
  error => {
    // do something with request error
    return Promise.reject(error)
  }
)

// response interceptor
service.interceptors.response.use(
  response => {
    const { data: res } = response
    
  

  
    if (res.code !== 1) {
      Message({
        message: res.msg,
        type: 'warning',
        duration: 5 * 1000
      })
      return Promise.reject(res)
    } else {
      return res
    }
  },
  error => {
    // const status = (error.response && error.response.status) || 400
    // switch (status) {
    //   case 400:
    //     error.message = '请求错误'
    //     break
    //   case 401:
    //     error.message = '未授权，请登录'
    //     break
    //   case 403:
    //     error.message = '拒绝访问'
    //     break
    //   case 404:
    //     error.message = `请求地址出错: ${ error.response.config.url }`
    //     break
    //   case 408:
    //     error.message = '请求超时'
    //     break
    //   case 500:
    //     error.message = '服务器内部错误'
    //     break
    //   case 501:
    //     error.message = '服务未实现'
    //     break
    //   case 502:
    //     error.message = '网关错误'
    //     break
    //   case 503:
    //     error.message = '服务不可用'
    //     break
    //   case 504:
    //     error.message = '网关超时'
    //     break
    //   case 505:
    //     error.message = 'HTTP版本不受支持'
    //     break
    //   default:
    //     break
    // }
    Message({
      message: error.message,
      type: 'error',
      duration: 5 * 1000
    })

    return Promise.reject(error)
  }
)

/**
 * get方法，对应get请求
 * @param {String} url [请求的url地址]
 * @param {Object} params [请求时携带的参数]
 */
export async function get(url, params) {
  return request(url, params, undefined, 'get')
}

/**
 * post方法，对应post请求
 * @param {String} url [请求的url地址]
 * @param {Object} params [请求时携带的参数]
 */
export async function post(url, data) {
  return request(url, undefined, data, 'post')
}
 
function request(url, params, data, method) {
   
  return new Promise((resolve, reject) => {
    service({ url, params, data, method })
      .then(res => {
        resolve(res)
      })
      .catch(e => {
        reject(e)
      })
  })
}
